import { useEffect } from "react";
import Card from "@mui/material/Card";
import { CardContent, Grid, Typography } from "@mui/material";

interface Props {
  eventId?: string;
}
export default function Page500({ eventId }: Props) {
  return (
    <>
      <Grid container>
        <Card variant="outlined">
          <CardContent>
            <Grid item>
              <Typography gutterBottom variant="h5" component="h2" display="initial">
                {"SystemError"}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body2" color="textSecondary">
                {"SystemErrorSubtitle"}
              </Typography>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
}
